module.exports = __webpack_public_path__ + "media/images/emblems/Wasterkingen-6dc6c42657a17ed2f34c42147e1b76b4.svg";